export default __webpack_public_path__ + "static/media/3_pushtech.2e434c39.svg";